const AuthService = {

  login(authData) {
    return new Promise((resolve, reject) => {
      axios.post('auth/login', authData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  logout() {
    return new Promise((resolve, reject) => {
      axios.post('auth/logout')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  refresh() {
    return new Promise((resolve, reject) => {
      axios.post('auth/refresh')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  me() {
    return new Promise((resolve, reject) => {
      axios.get('auth/me')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

};

export default AuthService;
